module.exports = __webpack_public_path__ + "static/img/bystage_white_06.78c1f02f.svg";